<template>
    <div class="footer">
        <div class="copyright wid1100">
            <p>{{ $t('footer.disclaimer') }}</p>
            <p>{{ $t('footer.copyright') }}</p>
        </div>
        <el-backtop :visibility-height="100" :right="20" :bottom="20"></el-backtop>
    </div>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style lang="scss" scoped>
.footer {
    margin-top: 20px;
    background-color: #f5f5f5;
    padding: 20px 0;
    text-align: center;
    font-size: 14px;
    color: #666;
    position: relative;

    .copyright {
        p {
            margin: 5px 0;
            line-height: 1.5;
            &:first-child {
                padding-bottom: 10px;
                border-bottom: 1px dotted #666;
            }
        }
    }
}
</style>